import type { IconSvgObject } from './types';

const GitCommitHorizontalIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 12H3M15 12H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default GitCommitHorizontalIcon;
